import { db } from "./firebase";
import { doc, setDoc, updateDoc, increment, getDoc } from "firebase/firestore";

export const updateCounter = async (type) => {
    const ref = doc(db, "counter", "stats");

    try {
        const snap = await getDoc(ref);

        if (!snap.exists()) {
            await setDoc(ref, {
                website_load: 0,
                share_click: 0,
                retrieve_click: 0,
            });
        }

        await updateDoc(ref, {
            [type]: increment(1),
        });

    } catch (err) {
        console.error(err);
    }
};